import { render, staticRenderFns } from "./RegisteredDataComponent.vue?vue&type=template&id=3b2ed31a&scoped=true"
import script from "./RegisteredDataComponent.vue?vue&type=script&lang=js"
export * from "./RegisteredDataComponent.vue?vue&type=script&lang=js"
import style0 from "./RegisteredDataComponent.vue?vue&type=style&index=0&id=3b2ed31a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2ed31a",
  null
  
)

export default component.exports